import { Button } from "Components/Button";
import Modal from "react-modal";
import { Client, PreOrderDetail } from "Requests/Partners/PreBudgets";
import { SelectAppointment } from "Components/SelectSchedule";
import { createToast } from "Utils/toastFunc";
import { useMutation } from "react-query";
import { rescheduleV2 } from "Requests/SchedulePartners";
import { useState } from "react";
import { ButtonsHolder } from "../styles";

interface ScheduleModalProps {
  isOpen: boolean;
  requestClose: () => void;
  refetch: () => void;
  acuityId: number | null;
  zipcode: string;
  client: Client;
  preOrderId: number;
  personData: PreOrderDetail;
}

export const RescheduleModal = ({
  isOpen,
  refetch,
  requestClose,
  acuityId,
  zipcode,
  client,
  preOrderId,
  personData,
}: ScheduleModalProps) => {
  const [appointment, setAppointment] = useState("");

  const rescheduleAppointmentMutation = useMutation({
    mutationFn: rescheduleV2,
  });

  const generateNewSchedule = async () => {
    try {
      if (!appointment) {
        throw new Error("Horário não selecionado");
      }

      if (acuityId) {
        await rescheduleAppointmentMutation.mutateAsync({
          appointment,
          id: acuityId,
          client_id: client.id,
          preOrderId,
        });

        createToast("success", "Reagendamento realizado com sucesso");
      }

      refetch();
      requestClose();
    } catch (errors: any) {
      const error = errors?.response?.data?.errors[0].message;

      if (error) {
        createToast("error", error);
        return;
      }

      if (errors?.message) {
        createToast("error", errors.message);
      }
    }
  };

  return (
    <Modal
      shouldCloseOnOverlayClick={false}
      isOpen={isOpen}
      onRequestClose={requestClose}
    >
      <SelectAppointment
        clientId={client.id}
        onSelectAppointment={setAppointment}
        preOrderId={preOrderId}
        zipcode={zipcode}
      >
        <ButtonsHolder>
          {appointment && (
            <Button
              onClick={generateNewSchedule}
              loading={rescheduleAppointmentMutation.isLoading}
              disabled={rescheduleAppointmentMutation.isLoading}
            >
              {acuityId
                ? "Prosseguir com o reagendamento"
                : "Prosseguir com o agendamento"}
            </Button>
          )}
          <Button
            outlined
            disabled={rescheduleAppointmentMutation.isLoading}
            onClick={requestClose}
          >
            Voltar para detalhes
          </Button>
        </ButtonsHolder>
      </SelectAppointment>
    </Modal>
  );
};
